export default {
  0: 'china',
  1: 'international',
  2: 'biki',
  3: 'momo',
  4: 'japanese',
  5: 'korea',
  6: 'europe',
  7: 'bidesk',
  8: 'bitWind',
  20200216120030: 'king',
  20200220142030: 'momo',
  813338302: 'king',
  277259945: 'momo',
  637852112: 'bitsg',
};
